import { useModalDeclaration } from 'v2/ui/utils/useModalToggle'

import { DataConnectionDetailModal } from './DataConnectionDetailModal/DataConnectionDetailModal'
import { DATA_CONNECTION_DETAIL_MODAL_KEY } from './constants'

export const useNewDataConnectionModal = () => {
    return useModalDeclaration(DATA_CONNECTION_DETAIL_MODAL_KEY, DataConnectionDetailModal)
}
